import { render, staticRenderFns } from "./AoRecruitingDashboard.vue?vue&type=template&id=65ace246&"
import script from "./AoRecruitingDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AoRecruitingDashboard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports